module.exports = __webpack_public_path__ + "a92ddc85d4f57ed69b4368e17a534a21.png";